import http from "../../http-common";

const get = (data) => http.post("/User/FilterUsers", data);

const create = (data) => http.post("/User/InsertUpdateUsers", data);

export default { get, create };
